
import React from 'react';

const ResetHeader: React.FC = () => {
  return (
    <div className="text-center mb-4">
      <h2 className="text-xl font-semibold">Reset Your Password</h2>
      <p className="text-muted-foreground mt-1">
        Enter your email and we'll send you a link to reset your password
      </p>
    </div>
  );
};

export default ResetHeader;
